var cathay = {
    actionButton: {
        text: 'shopMore.cathayButtonText',
        link: 'https://pay.cathaypacific.com/en_US/offers/uscreditcard.html'
    },
    certificateBalance: false,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    en: {
        termsAndConditionsLink: 'https://images.synchronycredit.com/essimages/cs/groups/ess_webasset/dualcard/@cathay/en/html/ess076014.html'
    },
    es: {
        termsAndConditionsLink: 'https://images.synchronycredit.com/essimages/cs/groups/ess_webasset/dualcard/@cathay/en/html/ess076014.html'
    },
    howToEarnPointsHeader: 'fullDetailsPage.cathayHowToEarnPointsHeader',
    faqs: 'https://www.cathaypacific.com/cx/en_US/faqs/cathay-membership-programme/asia-miles/earn-when-you-fly.html?cxsource=PAGELIST_HOTTOPICS_1&sideMenuOpen=true',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: false,
    links: [],
    translationKey: 'faqs.cathayDescription',
    snapshotTranslationKey: 'faqs.cathaySnapshotDescription',
    translationViewPrintKey: null,
    DUAL_CARD: {
        banner: 'cathay-banner-md.png',
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {
                cathay: { icon: ['far', 'plane'] },
                dining2: { icon: ['far', 'bag-shopping'] },
                world: { icon: ['far', 'earth-america'] },
                bonus: { icon: ['far', 'money-bills'] },
                adjustment: {
                    icon: ['far', 'calculator']
                }
            },
            titleKey: 'cathayEarnings.yourCathayEarnings'
        },
        rewardsBalance: true,
        valuePropImg: 'cathay-valueProp-dc.png',
        en: {
            propositions: [
                {
                    description: 'Earn 3 Asia Miles per $1 spent on Cathay and HK Express purchases.',
                    heading: 'earn',
                    points: '3 Asia Miles'
                },
                {
                    description: 'Earn 2 Asia Miles per $1 spent on dining and eligible dining delivery services.',
                    heading: 'earn',
                    points: '2 Asia Miles'
                },
                {
                    description: 'Earn 1 Asia Mile per $1 spent on everything else, where Mastercard is accepted worldwide.',
                    heading: 'earn',
                    points: '1 Asia Mile'
                },
                {
                    description: 'Earn 10 Status Points for every $5,000 in eligible purchases made each month up to a maximum of 100 Status Points per calendar year.',
                    heading: 'earn',
                    points: 'Status*'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga 3 Asia Miles por $1 gastado en compras de Cathay y HK Express.',
                    heading: 'obtenga',
                    points: '3 Asia Miles'
                },
                {
                    description: 'Obtenga 2 Asia Miles por $1 gastado en restaurantes y servicios de entrega de comida que califiquen.',
                    heading: 'obtenga',
                    points: '2 Asia Miles'
                },
                {
                    description: 'Obtenga 1 Asia Mile por $1 gastado en todo lo demás, en cualquier lugar donde se acepte Mastercard.',
                    heading: 'obtenga',
                    points: '1 Asia Mile'
                },
                {
                    description: 'Obtenga 10 Puntos de Estatus por cada $5,000 en compras elegibles realizadas cada mes hasta un máximo de 100 Puntos de Estatus por año calendario.',
                    heading: 'obtenga',
                    points: 'Estatus*'
                }
            ]
        }
    }
};
export default cathay;
